<template>
  <b-card
    no-body
  >
    <b-card-body>
      <b-row v-if="loading" style="height: 200px;" class="text-center">
        <b-col
          sm="12"
          align-self="center"
        >
          <i2-data-loading/>
        </b-col>
      </b-row>
      <line-chart v-if="!loading"
                  height="200" :values="series"
                  :toolbar="true"
                  :y-label="yLabel"
                  :x-label-itens="20"
                  title="Quantidade de Números e Novos Participantes"
      />
    </b-card-body>
  </b-card>
</template>

<script>
import I2DataLoading from '@/components/i2/layout/loading/I2DataLoading'
import LineChart from '@/components/i2/Graph/LineChart.vue'

export default {
  name: 'NumbersAndParticipantChart',
  components: {
    LineChart,
    I2DataLoading,
  },
  data() {
    return {
      dates: [],
      initialValue: [],
      colors: ['#5CC979'],
      loading: false,
      series: {},
      currentPromotion: {},
      yLabel: {
        text: 'Quantidades',
        format: val => new Intl.NumberFormat('pt-BR').format(val),
      },
    }
  },
  created() {
    const promotion = this.$user.getCurrentPromotion()
    if (!promotion) {
      return
    }
    this.currentPromotion = promotion
    this.getChartData()
  },
  methods: {
    getChartData() {
      this.loading = true
      this.$http.showLoader = false
      this.$http.get(`/metrics/promotion/${this.currentPromotion.uuid}/numbers-participants`)
        .then(response => {
          this.loading = false
          this.$http.showLoader = true
          this.series = response
        })
    },
  },
}
</script>

<style scoped>

</style>
